// import { useNavigate, useParams } from 'react-router-dom'
// import { useGetLMSDetail, useGetSvLMSBasicDetail } from '../../assets/nodeApi/getApi/getTeacherApi'
// import {
//     Box,
//     Grid2,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     Typography,
// } from '@mui/material'
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { useEffect, useRef, useState } from 'react';
// import { getFileUrl, Grid_Gap } from '../../shared/constants';
// import { MovingText } from '../../shared/utils/MovingText';
// import { SkeletonCom } from '../../shared/utils/SkeletonCom';
// import CustomDivider from '../../shared/utils/CustomDivider';
// import VideoPlayer from '../../shared/components/proteacher/VideoPlayer';
// import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
// import PdfFlipbook from '../../shared/components/proteacher/PdfViewer';
// import { useSearchParams } from 'react-router-dom';
// import { Icon } from '@iconify/react/dist/iconify.js';


// const ProTeacherLsmDetail = () => {
//     const [lessonDetail, setLessonDetail] = useState({})
//     const { id } = useParams()
//     const { data: CourseLMSDetail, isLoading } = useGetLMSDetail(id);
//     const { data: lmsBasicDetail, isLoading: isLmsBasicDetailLoading } = useGetSvLMSBasicDetail(id)
//     const {
//         data: milestoneData,
//         fetchNextPage: fetchNextMilestonePage,
//         hasNextPage: hasNextMilestonePage,
//         isFetchingNextPage: isFetchingNextMilestonePage,
//         isLoading: isMilestoneLoading,
//     } = useGetSvLMSMilestone(id);

//     const loadMoreMilestoneRef = useRef();

//     useEffect(() => {
//         const observer = new IntersectionObserver((entries) => {
//             if (entries[0].isIntersecting && hasNextMilestonePage) {
//                 fetchNextMilestonePage();
//             }
//         });

//         if (loadMoreMilestoneRef.current) {
//             observer.observe(loadMoreMilestoneRef.current);
//         }

//         return () => observer.disconnect();
//     }, [hasNextMilestonePage, fetchNextMilestonePage]);

//     const [expanded, setExpanded] = useState(null);
//     const [expandedChapter, setExpandedChapter] = useState(null);
//     const [expandedMilestone, setExpandedMilestone] = useState(null);
//     const [expandedSprint, setExpandedSprint] = useState(null);
//     const [expandedSession, setExpandedSession] = useState(null);
//     const [selectedFile, setSelectedFile] = useState(null);

//     const handlePress = (panel) => {
//         setExpanded(expanded === panel ? null : panel);
//     };

//     const handlePressChapter = (panel) => {
//         setExpandedChapter(expandedChapter === panel ? null : panel);
//     };

//     const handleMilestoneChange = (id) => {
//         setExpandedMilestone(expandedMilestone === id ? null : id);
//     };

//     const handleSprintChange = (id) => {
//         setExpandedSprint(expandedSprint === id ? null : id);
//     };

//     const handleSessionChange = (id) => {
//         setExpandedSession(expandedSession === id ? null : id);
//     };

//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const selectedLessonId = searchParams.get("lesson");

//     useEffect(() => {
//         if (!selectedLessonId || !CourseLMSDetail?.course?.milestones) return;

//         let foundLesson = null;

//         for (const milestone of CourseLMSDetail.course.milestones) {
//             for (const sprint of milestone.sprints || []) {
//                 for (const session of sprint.sessions || []) {
//                     for (const topic of session.lms || []) {
//                         for (const sub of topic.subtopics || []) {
//                             for (const file of sub.files || []) {
//                                 if (String(file.id) === String(selectedLessonId)) {
//                                     foundLesson = {
//                                         ...file,
//                                         // title: sub.name,
//                                         description: file.description,

//                                         // optional: keep path info for auto expand later
//                                         __milestoneId: milestone.milestoneId,
//                                         __sprintId: sprint.sprintId,
//                                         __sessionId: session?.sessionId,
//                                         __topicId: topic.id,
//                                         __subtopicId: sub.id,
//                                         __fileId: file.id

//                                     };
//                                     break;
//                                 }
//                             }
//                             if (foundLesson) break;
//                         }
//                         if (foundLesson) break;
//                     }
//                     if (foundLesson) break;
//                 }
//                 if (foundLesson) break;
//             }
//             if (foundLesson) break;
//         }

//         if (foundLesson) {
//             setLessonDetail(foundLesson);
//             // 🔹 Auto open correct accordions
//             setExpandedMilestone(foundLesson.__milestoneId);
//             setExpandedSprint(foundLesson.__sprintId);
//             setExpandedSession(foundLesson.__sessionId)
//             setExpanded(foundLesson.__topicId);
//             setExpandedChapter(foundLesson.__subtopicId);
//             setSelectedFile(foundLesson.__fileId)
//         }
//     }, [selectedLessonId, CourseLMSDetail]);

//     useEffect(() => {
//         if (!selectedLessonId) {
//             setLessonDetail({});
//             setExpandedMilestone(null);
//             setExpandedSprint(null);
//             setExpandedSession(null)
//             setExpanded(null);
//             setExpandedChapter(null);
//             setSelectedFile(null)
//         }
//     }, [selectedLessonId]);

//     return (
//         <>
//             <Grid2 container spacing={Grid_Gap}>
//                 <Grid2 children size={{ xs: 12, sm: 8 }} >
//                     <NormalContainerWithHeader >
//                         {
//                             isLoading && (
//                                 <Box sx={{ padding: "1rem" }}>
//                                     <SkeletonCom height={300} style={{ borderRadius: "10px" }} />
//                                 </Box>
//                             )
//                         }

//                         {
//                             !isLoading && (
//                                 <Box sx={{ textAlign: "center", mt: 2 }}>

//                                     {/* NO LESSON SELECTED → SHOW COURSE INFO */}
//                                     {!lessonDetail?.file_type ? (
//                                         <>
//                                             <Box
//                                                 component="img"
//                                                 src={getFileUrl(lmsBasicDetail?.course?.thumbnail)}
//                                                 alt="Course Thumbnail"
//                                                 sx={{
//                                                     width: "100%",
//                                                     height: 350,
//                                                     objectFit: "cover",
//                                                     borderRadius: 2,
//                                                     backgroundColor: "#eee",
//                                                 }}
//                                             />

//                                             <CustomDivider />

//                                             <Typography variant="h4" textAlign="start">
//                                                 {lmsBasicDetail?.course?.name}
//                                             </Typography>

//                                             <CustomDivider size="1rem" />

//                                             <Typography
//                                                 variant="body2"
//                                                 color="secondary.light"
//                                                 lineHeight="18px"
//                                                 textAlign="start"
//                                             >
//                                                 {lmsBasicDetail?.course?.description}
//                                             </Typography>
//                                         </>
//                                     ) : (
//                                         <>
//                                             {/* LESSON SELECTED → SHOW MEDIA */}

//                                             {/* VIDEO */}
//                                             {lessonDetail.file_type === "video" && (
//                                                 <VideoPlayer
//                                                     url={getFileUrl(lessonDetail.file_path)}
//                                                     height={350}
//                                                 />
//                                             )}

//                                             {/* PDF / DOCUMENT */}
//                                             {lessonDetail.file_type === "document" && (
//                                                 <PdfFlipbook
//                                                     uri={getFileUrl(lessonDetail.file_path)}
//                                                 />
//                                             )}

//                                             {/* IMAGE */}
//                                             {lessonDetail.file_type !== "video" &&
//                                                 lessonDetail.file_type !== "document" && (
//                                                     <Box
//                                                         component="img"
//                                                         src={getFileUrl(lessonDetail.file_path)}
//                                                         sx={{
//                                                             width: "100%",
//                                                             height: 350,
//                                                             objectFit: "contain",
//                                                             borderRadius: 2,
//                                                             backgroundColor: "#fafafa",
//                                                         }}
//                                                     />
//                                                 )}

//                                             <CustomDivider />

//                                             <Typography variant="body2" textAlign="start">
//                                                 {lessonDetail.description}
//                                             </Typography>
//                                         </>
//                                     )}
//                                 </Box>
//                             )
//                         }

//                     </NormalContainerWithHeader>
//                 </Grid2>
//                 <Grid2 children size={{ xs: 12, sm: 4 }}>

//                     <NormalContainerWithHeader   >
//                         <Box
//                             sx={{
//                                 height: "90vh",
//                                 overflowY: "auto",

//                             }}
//                         >
//                             {
//                                 isLoading &&
//                                 <Box sx={{ padding: "1rem" }}>
//                                     {
//                                         [...Array(5)].map((_, index) => (
//                                             <Box key={index}>
//                                                 <SkeletonCom height={50} style={{ borderRadius: "5px" }} />
//                                                 <CustomDivider size={"1rem"} />
//                                             </Box>

//                                         ))
//                                     }
//                                 </Box>

//                             }

//                             {
//                                 !isLoading && <Box sx={{ mt: 2 }}>
//                                     {
//                                         CourseLMSDetail?.course?.milestones?.map((milestone, topicIndex) => (
//                                             <Box key={milestone.milestoneId} sx={{ mb: 3 }}>
//                                                 <Accordion
//                                                     expanded={expandedMilestone === milestone.milestoneId}
//                                                     onChange={() => handleMilestoneChange(milestone.milestoneId)}
//                                                     sx={{ boxShadow: "none", border: "1px solid #4169E1", backgroundColor: "#fff" }}
//                                                 >
//                                                     <AccordionSummary expandIcon={<ExpandMoreIcon />} >
//                                                         <Typography variant="body1" fontWeight={600}>Milestone {topicIndex + 1} : {milestone.milestoneName}</Typography>
//                                                     </AccordionSummary>

//                                                     <AccordionDetails >
//                                                         {milestone.sprints?.map((sprint, subTopicIndex) => (
//                                                             <Accordion
//                                                                 key={sprint.sprintId}
//                                                                 expanded={expandedSprint === sprint.sprintId}
//                                                                 onChange={() => handleSprintChange(sprint.sprintId)}
//                                                                 sx={{
//                                                                     backgroundColor: "#F7FAFF", boxShadow: "none", my: 1, borderRadius: 1, border: "none",

//                                                                     "&:before": {
//                                                                         display: "none",
//                                                                     },
//                                                                 }}
//                                                             >
//                                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />}
//                                                                     sx={{ border: "none", bgcolor: "transparent" }}
//                                                                 >
//                                                                     <Typography variant="body2" fontWeight={600}>Sprint {subTopicIndex + 1} : {sprint?.sprintName}</Typography>
//                                                                 </AccordionSummary>


//                                                                 <AccordionDetails>


//                                                                     {sprint?.sessions?.map((sprint, subTopicIndex) => (
//                                                                         <Accordion
//                                                                             key={sprint.sessionId}
//                                                                             expanded={expandedSession === sprint.sessionId}
//                                                                             onChange={() => handleSessionChange(sprint.sessionId)}
//                                                                             sx={{ boxShadow: "none", border: "1px solid #4169E1", backgroundColor: "#fff" }}
//                                                                         >
//                                                                             <AccordionSummary expandIcon={<ExpandMoreIcon />}
//                                                                             >
//                                                                                 <Typography variant="body2" fontWeight={600}>Session {subTopicIndex + 1} : {sprint?.sessionName}</Typography>
//                                                                             </AccordionSummary>

//                                                                             <CustomDivider size={"0.5rem"} />
//                                                                             <AccordionDetails>


//                                                                                 {
//                                                                                     sprint?.lms?.map((topic, topicIndex) => {

//                                                                                         return (
//                                                                                             <Box key={topic?.id} sx={styles.milestoneContainer}>
//                                                                                                 <Accordion
//                                                                                                     expanded={expanded === topic?.id}
//                                                                                                     onChange={() => handlePress(topic?.id)}
//                                                                                                     sx={{ bgcolor: "#F7FAFF", boxShadow: "none" }}
//                                                                                                 >
//                                                                                                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                                                                                         <Typography variant="subtitle1">{topic?.name}</Typography>
//                                                                                                     </AccordionSummary>





//                                                                                                     <AccordionDetails sx={styles.chapterContainer}>
//                                                                                                         {topic?.subtopics?.map((sub) => {

//                                                                                                             return (
//                                                                                                                 <Box key={sub?.id} sx={styles.chapterBox}>
//                                                                                                                     <Accordion
//                                                                                                                         expanded={expandedChapter === sub?.id}
//                                                                                                                         onChange={() => handlePressChapter(sub?.id)}
//                                                                                                                         sx={styles.accordionChapter}
//                                                                                                                     >
//                                                                                                                         <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                                                                                                             <Box sx={styles.chapterTitleRow}>
//                                                                                                                                 <Box sx={styles.bigRedDot} />
//                                                                                                                                 <Typography variant="subtitle2">
//                                                                                                                                     {sub?.name}
//                                                                                                                                 </Typography>
//                                                                                                                             </Box>
//                                                                                                                         </AccordionSummary>

//                                                                                                                         <AccordionDetails sx={styles.itemContainer}>
//                                                                                                                             {sub?.files?.map((file) => (
//                                                                                                                                 <Box
//                                                                                                                                     key={file?.id}
//                                                                                                                                     sx={{
//                                                                                                                                         display: "flex",
//                                                                                                                                         alignItems: "center",
//                                                                                                                                         gap: "0.5rem",
//                                                                                                                                         padding: 1,
//                                                                                                                                         bgcolor: file?.id === selectedFile ? "#4169E1" : "transparent",
//                                                                                                                                         borderRadius: 1,
//                                                                                                                                         cursor: "pointer"
//                                                                                                                                     }}
//                                                                                                                                     onClick={() => {
//                                                                                                                                         setLessonDetail({
//                                                                                                                                             ...file,
//                                                                                                                                             title: sub?.name,
//                                                                                                                                             description: sub?.description,
//                                                                                                                                         });

//                                                                                                                                         navigate(`?lesson=${file?.id}`, { replace: false });
//                                                                                                                                         window.scrollTo({ top: 0, behavior: "smooth" });
//                                                                                                                                     }}
//                                                                                                                                 >
//                                                                                                                                     {
//                                                                                                                                         file?.file_type === "video"
//                                                                                                                                             ? <Icon icon="logos:youtube-icon" width="30" height="27" />
//                                                                                                                                             : file?.file_type === "document"
//                                                                                                                                                 ? <Icon icon="vscode-icons:file-type-pdf2" width="32" height="32" />
//                                                                                                                                                 : <Icon icon="fa6-solid:image" width="28" height="20" style={{ color: file?.id === selectedFile ? "#fff" : "#000" }} />
//                                                                                                                                     }
//                                                                                                                                     <MovingText text={file?.file_name} variant={"body2"} color={file?.id === selectedFile ? "#fff" : "#000"} />
//                                                                                                                                 </Box>

//                                                                                                                             ))}
//                                                                                                                             {sub?.paragraphs?.map((para) => (
//                                                                                                                                 <Box
//                                                                                                                                     key={para?.id}
//                                                                                                                                     sx={{ my: 1 }}

//                                                                                                                                 >

//                                                                                                                                     <Typography>{para?.description}</Typography>

//                                                                                                                                 </Box>
//                                                                                                                             ))}
//                                                                                                                         </AccordionDetails>
//                                                                                                                     </Accordion>
//                                                                                                                 </Box>
//                                                                                                             );
//                                                                                                         })}
//                                                                                                     </AccordionDetails>






//                                                                                                 </Accordion>
//                                                                                             </Box>
//                                                                                         );
//                                                                                     })

//                                                                                 }

//                                                                             </AccordionDetails>
//                                                                         </Accordion>
//                                                                     ))}
//                                                                 </AccordionDetails>
//                                                             </Accordion>
//                                                         ))}
//                                                     </AccordionDetails>
//                                                 </Accordion>
//                                             </Box>
//                                         ))}
//                                 </Box>
//                             }
//                         </Box>
//                     </NormalContainerWithHeader>
//                 </Grid2>

//             </Grid2>
//         </>
//     )
// }


// const styles = {
//     milestoneContainer: {
//         overflow: 'hidden',
//         backgroundColor: 'transparent',
//     },
//     sprintContainer: {
//         overflow: 'hidden',
//         backgroundColor: '#F7FAFF',
//         boxShadow: "none"
//     },
//     accordionTop: {
//         backgroundColor: 'transparent',
//         borderRadius: 5,
//         boxShadow: 'none',
//     },
//     chapterContainer: {
//         backgroundColor: 'white',
//         backgroundColor: 'transparent',
//         padding: '8px 5px',
//     },
//     chapterBox: {
//         overflow: 'hidden',
//         borderRadius: 0,
//     },
//     accordionChapter: {
//         padding: '8px 5px',
//         borderRadius: 0,
//         boxShadow: 'none',
//         borderBottom: "1px solid #ECECEC"

//     },
//     chapterTitleRow: {
//         display: 'flex',
//         alignItems: 'center',
//         borderRadius: '0',
//     },
//     chapterTitleText: {
//         // marginLeft: 1,
//     },
//     bigRedDot: {
//         width: 10,
//         height: 10,
//         borderRadius: '50%',
//         backgroundColor: 'blue.main',
//         border: '3px solid #fff',
//     },
//     itemContainer: {
//         backgroundColor: '#F5F5F5',
//         padding: '8px 12px',
//         boxShadow: 'none',
//         borderRadius: 1
//     },





// };


// export default ProTeacherLsmDetail




import { useGetSvLMSBasicDetail, useGetSvLMSMilestone, useGetSvLMSSprint, useGetSvLMSSpritDetail } from '../../assets/nodeApi/getApi/getTeacherApi'
import {
    Box,
    Grid2,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useRef, useState } from 'react';
import { getFileUrl, Grid_Gap } from '../../shared/constants';
import { MovingText } from '../../shared/utils/MovingText';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import VideoPlayer from '../../shared/components/proteacher/VideoPlayer';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import PdfFlipbook from '../../shared/components/proteacher/PdfViewer';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useGetLmsSubtopic, useGetLmsSubtopicDetail } from '../../assets/api/useAdminApi';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";



const ProTeacherLsmDetail = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()
    const { id } = useParams()
    const { data: lmsBasicDetail, isLoading: isLmsBasicDetailLoading } = useGetSvLMSBasicDetail(id)
    // const [expandedChapter, setExpandedChapter] = useState(null);

    const [lessonDetail, setLessonDetail] = useState({})
    // const [expandedTopic, setExpandedTopic] = useState(null);
    // const [expandedMilestone, setExpandedMilestone] = useState(null);
    // const [expandedSprint, setExpandedSprint] = useState(null);
    // const [expandedSession, setExpandedSession] = useState(null);
    // const [selectedFile, setSelectedFile] = useState(null);


    const [expandedMilestone, setExpandedMilestone] = useState(searchParams.get("milestone"));
    const [expandedSprint, setExpandedSprint] = useState(searchParams.get("sprint"));
    const [expandedSession, setExpandedSession] = useState(searchParams.get("session"));
    const [expandedTopic, setExpandedTopic] = useState(searchParams.get("topic"));
    const [expandedChapter, setExpandedChapter] = useState(searchParams.get("subtopic"));
    const [selectedFile, setSelectedFile] = useState(searchParams.get("file"));
        const { data: subTopicDetail, isLoading: subTopicLoading } = useGetLmsSubtopicDetail(expandedChapter)

    const updateQueryParams = (params) => {
        const newParams = new URLSearchParams(searchParams);

        Object.keys(params).forEach((key) => {
            if (params[key]) {
                newParams.set(key, params[key]);
            } else {
                newParams.delete(key);
            }
        });

        setSearchParams(newParams);
    };



    const {
        data: milestoneData,
        fetchNextPage: fetchNextMilestonePage,
        hasNextPage: hasNextMilestonePage,
        isFetchingNextPage: isFetchingNextMilestonePage,
        isLoading: isMilestoneLoading,
    } = useGetSvLMSMilestone(id);

    const loadMoreMilestoneRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasNextMilestonePage) {
                fetchNextMilestonePage();
            }
        });

        if (loadMoreMilestoneRef.current) {
            observer.observe(loadMoreMilestoneRef.current);
        }

        return () => observer.disconnect();
    }, [hasNextMilestonePage, fetchNextMilestonePage]);



    const {
        data: sprintData,
        fetchNextPage: fetchNextSprintPage,
        hasNextPage: hasNextSprintPage,
        isFetchingNextPage: isFetchingNextSprintPage,
        isLoading: isSprintLoading,
    } = useGetSvLMSSprint(expandedMilestone);

    const loadMoreSprintRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasNextSprintPage) {
                fetchNextSprintPage();
            }
        });

        if (loadMoreSprintRef.current) {
            observer.observe(loadMoreSprintRef.current);
        }

        return () => observer.disconnect();
    }, [hasNextSprintPage, fetchNextSprintPage]);

    const { data: lmsSprintDetail, isLoading: isLmsSprintDetailLoading } = useGetSvLMSSpritDetail(expandedSprint)


    const {
        data: subtopicData,
        fetchNextPage: fetchNextSubtopicPage,
        hasNextPage: hasNextSubtopicPage,
        isFetchingNextPage: isFetchingNextSubtopicPage,
        isLoading: islmsSubTopicLoading,
    } = useGetLmsSubtopic(expandedTopic);

    const loadMoreSubTopicRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasNextSubtopicPage) {
                fetchNextSubtopicPage();
            }
        });

        if (loadMoreSubTopicRef.current) {
            observer.observe(loadMoreSubTopicRef.current);
        }

        return () => observer.disconnect();
    }, [hasNextSubtopicPage]);



    // const handleMilestoneChange = (id) => {
    //     setExpandedMilestone(expandedMilestone === id ? null : id);
    //     setExpandedSprint(null)
    //     setExpandedSession(null)
    //     setExpandedTopic(null)
    //     setExpandedChapter(null)
    // };

    // const handleSprintChange = (id) => {
    //     setExpandedSprint(expandedSprint === id ? null : id);
    //     setExpandedSession(null)
    //     setExpandedTopic(null)
    //     setExpandedChapter(null)
    // };

    // const handleSessionChange = (id) => {
    //     setExpandedSession(expandedSession === id ? null : id);
    //     setExpandedTopic(null)
    //     setExpandedChapter(null)
    // };

    // const handlePressTopic = (panel) => {
    //     setExpandedTopic(expandedTopic === panel ? null : panel);
    //     setExpandedChapter(null)
    // };

    // const handlePressChapter = (panel) => {
    //     setExpandedChapter(expandedChapter === panel ? null : panel);
    // };



    const handleMilestoneChange = (id) => {
        const newValue = expandedMilestone === id ? null : id;

        setExpandedMilestone(newValue);
        setExpandedSprint(null);
        setExpandedSession(null);
        setExpandedTopic(null);
        setExpandedChapter(null);

        updateQueryParams({
            milestone: newValue,
            sprint: null,
            session: null,
            topic: null,
            subtopic: null,
            file: null,
        });
    };


    const handleSprintChange = (id) => {
        const newValue = expandedSprint === id ? null : id;

        setExpandedSprint(newValue);
        setExpandedSession(null);
        setExpandedTopic(null);
        setExpandedChapter(null);

        updateQueryParams({
            sprint: newValue,
            session: null,
            topic: null,
            subtopic: null,
            file: null,
        });
    };


    const handleSessionChange = (id) => {
        const newValue = expandedSession === id ? null : id;

        setExpandedSession(newValue);
        setExpandedTopic(null);
        setExpandedChapter(null);

        updateQueryParams({
            session: newValue,
            topic: null,
            subtopic: null,
            file: null,
        });
    };


    const handlePressTopic = (id) => {
        const newValue = expandedTopic === id ? null : id;

        setExpandedTopic(newValue);
        setExpandedChapter(null);

        updateQueryParams({
            topic: newValue,
            subtopic: null,
            file: null,
        });
    };


    const handlePressChapter = (id) => {
        const newValue = expandedChapter === id ? null : id;

        setExpandedChapter(newValue);

        updateQueryParams({
            subtopic: newValue,
            file: null,
        });
    };

    useEffect(() => {
        if (subTopicDetail && selectedFile) {
            const file = subTopicDetail?.subtopic?.lms_subtopic_files?.find(
                (f) => f.id == selectedFile
            );

            if (file) {
                setLessonDetail({
                    ...file,
                    title: subTopicDetail?.subtopic?.name,
                    description: subTopicDetail?.subtopic?.description,
                });
            }
        }
    }, [subTopicDetail, selectedFile]);


    return (
        <>
            <Grid2 container spacing={Grid_Gap}>
                <Grid2 children size={{ xs: 12, sm: 8 }} >
                    <NormalContainerWithHeader >
                        {
                            isLmsBasicDetailLoading && (
                                <Box sx={{ padding: "1rem" }}>
                                    <SkeletonCom height={300} style={{ borderRadius: "10px" }} />
                                </Box>
                            )
                        }

                        {
                            !isLmsBasicDetailLoading && (
                                <Box sx={{ textAlign: "center", mt: 2 }}>

                                    {/* NO LESSON SELECTED → SHOW COURSE INFO */}
                                    {!lessonDetail?.file_type ? (
                                        <>
                                            <Box
                                                component="img"
                                                src={getFileUrl(lmsBasicDetail?.course?.thumbnail)}
                                                alt="Course Thumbnail"
                                                sx={{
                                                    width: "100%",
                                                    height: 350,
                                                    objectFit: "cover",
                                                    borderRadius: 2,
                                                    backgroundColor: "#eee",
                                                }}
                                            />

                                            <CustomDivider />

                                            <Typography variant="h4" textAlign="start">
                                                {lmsBasicDetail?.course?.name}
                                            </Typography>

                                            <CustomDivider size="1rem" />

                                            <Typography
                                                variant="body2"
                                                color="secondary.light"
                                                lineHeight="18px"
                                                textAlign="start"
                                            >
                                                {lmsBasicDetail?.course?.description}
                                            </Typography>
                                        </>
                                    ) : (
                                        <>
                                            {/* LESSON SELECTED → SHOW MEDIA */}

                                            {/* VIDEO */}
                                            {lessonDetail.file_type === "video" && (
                                                <VideoPlayer
                                                    url={getFileUrl(lessonDetail.file_path)}
                                                    height={350}
                                                />
                                            )}

                                            {/* PDF / DOCUMENT */}
                                            {lessonDetail.file_type === "document" && (
                                                <PdfFlipbook
                                                    uri={getFileUrl(lessonDetail.file_path)}
                                                />
                                            )}

                                            {/* IMAGE */}
                                            {lessonDetail.file_type !== "video" &&
                                                lessonDetail.file_type !== "document" && (
                                                    <Box
                                                        component="img"
                                                        src={getFileUrl(lessonDetail.file_path)}
                                                        sx={{
                                                            width: "100%",
                                                            height: 350,
                                                            objectFit: "contain",
                                                            borderRadius: 2,
                                                            backgroundColor: "#fafafa",
                                                        }}
                                                    />
                                                )}

                                            <CustomDivider />

                                            <Typography variant="body2" textAlign="start">
                                                {lessonDetail.description}
                                            </Typography>
                                        </>
                                    )}
                                </Box>
                            )
                        }

                    </NormalContainerWithHeader>
                </Grid2>
                <Grid2 children size={{ xs: 12, sm: 4 }}>

                    <NormalContainerWithHeader   >
                        <Box
                            sx={{
                                height: "90vh",
                                overflowY: "auto",

                            }}
                        >
                            {
                                isMilestoneLoading &&
                                <Box sx={{ padding: "1rem" }}>
                                    {
                                        [...Array(5)].map((_, index) => (
                                            <Box key={index}>
                                                <SkeletonCom height={50} style={{ borderRadius: "5px" }} />
                                                <CustomDivider size={"1rem"} />
                                            </Box>

                                        ))
                                    }
                                </Box>

                            }

                            {
                                !isMilestoneLoading && <Box sx={{ mt: 2 }}>

                                    {milestoneData?.pages.map((page, milestonePageIndex) =>
                                        page.milestones.map((milestone, milestonesIndex) => (
                                            <Box key={milestone.milestoneId} sx={{ mb: 3 }}>
                                                <Accordion

                                                    expanded={expandedMilestone === milestone.milestoneId}
                                                    onChange={() => handleMilestoneChange(milestone.milestoneId)}
                                                    sx={{ boxShadow: "none", border: "1px solid #4169E1", backgroundColor: "#fff" }}
                                                >
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                                        <Typography variant="body1" fontWeight={600}>Milestone {milestonePageIndex * 10 + (milestonesIndex + 1)} : {milestone.milestoneName}</Typography>
                                                    </AccordionSummary>

                                                    <AccordionDetails>
                                                        {/* ----------- LOAD SUBTOPICS ONLY FOR OPENED TOPIC ----------- */}
                                                        {expandedMilestone === milestone.milestoneId && (
                                                            <>
                                                                {
                                                                    isSprintLoading ? <Typography>spring loading.....</Typography> :
                                                                        <>

                                                                            {sprintData?.pages.map((page, sprintPageIndex) =>
                                                                                page.sprints.map((sprint, subTopicIndex) => (
                                                                                    <Accordion
                                                                                        key={sprint.sprintId}
                                                                                        expanded={expandedSprint === sprint.sprintId}
                                                                                        onChange={() => handleSprintChange(sprint.sprintId)}
                                                                                        sx={{
                                                                                            backgroundColor: "#F7FAFF", boxShadow: "none", my: 1, borderRadius: 1, border: "none",
                                                                                            "&:before": {
                                                                                                display: "none",
                                                                                            },
                                                                                        }}
                                                                                    >
                                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                                                                            sx={{ border: "none", bgcolor: "transparent" }}
                                                                                        >
                                                                                            <Typography variant="body2" fontWeight={600}>Sprint {sprintPageIndex * 10 + (subTopicIndex + 1)} : {sprint?.sprintName}</Typography>
                                                                                        </AccordionSummary>

                                                                                        <AccordionDetails>

                                                                                            {

                                                                                                expandedSprint === sprint.sprintId && (
                                                                                                    <>



                                                                                                        {
                                                                                                            isLmsSprintDetailLoading ? <Typography>sprint Data loading....</Typography> :
                                                                                                                <>
                                                                                                                    {lmsSprintDetail?.sessions?.map((sprint, subTopicIndex) => (
                                                                                                                        <Accordion
                                                                                                                            key={sprint.sessionId}
                                                                                                                            expanded={expandedSession === sprint.sessionId}
                                                                                                                            onChange={() => handleSessionChange(sprint.sessionId)}
                                                                                                                            sx={{ boxShadow: "none", border: "1px solid #4169E1", backgroundColor: "#fff" }}
                                                                                                                        >
                                                                                                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                                                                                                            >
                                                                                                                                <Typography variant="body2" fontWeight={600}>Session {subTopicIndex + 1} : {sprint?.sessionName}</Typography>
                                                                                                                            </AccordionSummary>

                                                                                                                            <CustomDivider size={"0.5rem"} />
                                                                                                                            <AccordionDetails>

                                                                                                                                {
                                                                                                                                    sprint?.lms?.map((topic, topicIndex) => {

                                                                                                                                        return (
                                                                                                                                            <Box key={topic?.id} sx={styles.milestoneContainer}>
                                                                                                                                                <Accordion
                                                                                                                                                    expanded={expandedTopic == topic?.id}
                                                                                                                                                    onChange={() => handlePressTopic(topic?.id)}
                                                                                                                                                    sx={{ bgcolor: "#F7FAFF", boxShadow: "none" }}
                                                                                                                                                >
                                                                                                                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                                                                                                        <Typography variant="subtitle1">{topic?.name}</Typography>
                                                                                                                                                    </AccordionSummary>
                                                                                                                                                    <AccordionDetails sx={styles.chapterContainer}>
                                                                                                                                                        {expandedTopic == topic?.id && (
                                                                                                                                                            <>
                                                                                                                                                                {
                                                                                                                                                                    islmsSubTopicLoading ? <Typography>subtopic loading ....</Typography> :
                                                                                                                                                                        <>

                                                                                                                                                                            {subtopicData?.pages.map((page, pageIndex) =>
                                                                                                                                                                                page.subtopics.map((sub, index) => (
                                                                                                                                                                                    <Accordion
                                                                                                                                                                                        expanded={expandedChapter == sub?.id}
                                                                                                                                                                                        onChange={() => handlePressChapter(sub?.id)}
                                                                                                                                                                                        sx={styles.accordionChapter}
                                                                                                                                                                                    >
                                                                                                                                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                                                                                                                                            <Box sx={styles.chapterTitleRow}>
                                                                                                                                                                                                <Box sx={styles.bigRedDot} />
                                                                                                                                                                                                <Typography variant="subtitle2">
                                                                                                                                                                                                    {sub?.name}
                                                                                                                                                                                                </Typography>
                                                                                                                                                                                            </Box>
                                                                                                                                                                                        </AccordionSummary>


                                                                                                                                                                                        <CustomDivider size={"0.5rem"} />

                                                                                                                                                                                        <AccordionDetails sx={styles.itemContainer}>

                                                                                                                                                                                          
                                                                                                                                                                                                {subTopicLoading ? <Typography>file loading ....</Typography> :
                                                                                                                                                                                                    <>
                                                                                                                                                                                                        {subTopicDetail?.subtopic?.lms_subtopic_files?.map((file) => (
                                                                                                                                                                                                            <Box
                                                                                                                                                                                                                key={file?.id}
                                                                                                                                                                                                                sx={{
                                                                                                                                                                                                                    display: "flex",
                                                                                                                                                                                                                    alignItems: "center",
                                                                                                                                                                                                                    gap: "0.5rem",
                                                                                                                                                                                                                    padding: 1,
                                                                                                                                                                                                                    bgcolor: file?.id == selectedFile ? "#4169E1" : "transparent",
                                                                                                                                                                                                                    borderRadius: 1,
                                                                                                                                                                                                                    cursor: "pointer"
                                                                                                                                                                                                                }}
                                                                                                                                                                                                                onClick={() => {
                                                                                                                                                                                                                    setLessonDetail({
                                                                                                                                                                                                                        ...file,
                                                                                                                                                                                                                        id: file?.id,
                                                                                                                                                                                                                        title: sub?.name,
                                                                                                                                                                                                                        description: sub?.description,
                                                                                                                                                                                                                    });
                                                                                                                                                                                                                    setSelectedFile(file?.id);

                                                                                                                                                                                                                    // navigate(`?lesson=${file?.id}`, { replace: false });
                                                                                                                                                                                                                    updateQueryParams({
                                                                                                                                                                                                                        file: file?.id,
                                                                                                                                                                                                                    });
                                                                                                                                                                                                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                                                                                                                                                                                                }}
                                                                                                                                                                                                            >
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    file?.file_type === "video"
                                                                                                                                                                                                                        ? <Icon icon="logos:youtube-icon" width="30" height="27" />
                                                                                                                                                                                                                        : file?.file_type === "document"
                                                                                                                                                                                                                            ? <Icon icon="vscode-icons:file-type-pdf2" width="32" height="32" />
                                                                                                                                                                                                                            : <Icon icon="fa6-solid:image" width="28" height="20" style={{ color: file?.id == selectedFile ? "#fff" : "#000" }} />
                                                                                                                                                                                                                }
                                                                                                                                                                                                                <MovingText text={file?.file_name} variant={"body2"} color={file?.id == selectedFile ? "#fff" : "#000"} />
                                                                                                                                                                                                            </Box>

                                                                                                                                                                                                        ))}
                                                                                                                                                                                                        {subTopicDetail?.subtopic?.lms_paragraphs?.map((para) => (
                                                                                                                                                                                                            <Box
                                                                                                                                                                                                                key={para?.id}
                                                                                                                                                                                                                sx={{ my: 1 }}

                                                                                                                                                                                                            >

                                                                                                                                                                                                                <Typography>{para?.description}</Typography>

                                                                                                                                                                                                            </Box>
                                                                                                                                                                                                        ))}
                                                                                                                                                                                                    </>

                                                                                                                                                                                                }



                                                                                                                                                                                          
                                                                                                                                                                                            


                                                                                                                                                                                        </AccordionDetails>


                                                                                                                                                                                    </Accordion>
                                                                                                                                                                                ))
                                                                                                                                                                            )}

                                                                                                                                                                        </>
                                                                                                                                                                }



                                                                                                                                                                {isFetchingNextSubtopicPage && <p>Loading more subtopics...</p>}

                                                                                                                                                                <div ref={loadMoreSubTopicRef}></div>
                                                                                                                                                            </>
                                                                                                                                                        )}


                                                                                                                                                    </AccordionDetails>

                                                                                                                                                </Accordion>
                                                                                                                                            </Box>
                                                                                                                                        );
                                                                                                                                    })

                                                                                                                                }
                                                                                                                            </AccordionDetails>
                                                                                                                        </Accordion>
                                                                                                                    ))}
                                                                                                                </>
                                                                                                        }


                                                                                                    </>
                                                                                                )
                                                                                            }

                                                                                        </AccordionDetails>




                                                                                    </Accordion>
                                                                                ))
                                                                            )}
                                                                        </>
                                                                }


                                                                {isFetchingNextSprintPage && <p>Loading more subtopics...</p>}

                                                                <div ref={loadMoreSprintRef}></div>
                                                            </>
                                                        )}



                                                        {isFetchingNextSprintPage && <p>Loading more sprint...</p>}

                                                        <div ref={loadMoreSprintRef}></div>
                                                    </AccordionDetails>


                                                </Accordion>
                                            </Box>
                                        ))
                                    )}

                                    {isFetchingNextMilestonePage && <p>Loading more milestone...</p>}

                                    <div ref={loadMoreMilestoneRef}></div>
                                </Box>
                            }
                        </Box>
                    </NormalContainerWithHeader>
                </Grid2>

            </Grid2>
        </>
    )
}


const styles = {
    milestoneContainer: {
        overflow: 'hidden',
        backgroundColor: 'transparent',
    },
    sprintContainer: {
        overflow: 'hidden',
        backgroundColor: '#F7FAFF',
        boxShadow: "none"
    },
    accordionTop: {
        backgroundColor: 'transparent',
        borderRadius: 5,
        boxShadow: 'none',
    },
    chapterContainer: {
        backgroundColor: 'white',
        backgroundColor: 'transparent',
        padding: '8px 5px',
    },
    chapterBox: {
        overflow: 'hidden',
        borderRadius: 0,
    },
    accordionChapter: {
        padding: '8px 5px',
        borderRadius: 0,
        boxShadow: 'none',
        borderBottom: "1px solid #ECECEC"

    },
    chapterTitleRow: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '0',
    },
    chapterTitleText: {
        // marginLeft: 1,
    },
    bigRedDot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: 'blue.main',
        border: '3px solid #fff',
    },
    itemContainer: {
        backgroundColor: '#F5F5F5',
        padding: '8px 12px',
        boxShadow: 'none',
        borderRadius: 1
    },





};


export default ProTeacherLsmDetail

